import * as angular from "angular";
import {IHttpService} from "angular";
import {ApiConfig} from "../../commons/models/api-config.model";

export class SignupRequestsService {

  /* @ngInject */
  constructor(private $http: IHttpService, private apiConfig: ApiConfig) {
  }

  getPurchasedSubscription(token) {
    const url = this.apiConfig.baseUrl + `/azure/fulfillment/resolve`;
    return new Promise((resolve, reject) => {
      this.$http.post(url, {token: token})
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  createOrganization(organization, subscriptionId, planId, quantity) {
    const url = this.apiConfig.baseUrl + `/azure/fulfillment/create`;
    return new Promise((resolve, reject) => {
      this.$http.post(url, {
        subscriptionId: subscriptionId,
        planId: planId,
        quantity: quantity,
        organizationName: organization.name
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  activateSubscription(subscriptionId) {
    const url = this.apiConfig.baseUrl + `/azure/fulfillment`;
    return new Promise((resolve, reject) => {
      this.$http.post(url + '/activate/' + subscriptionId, null)
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

}

angular
  .module('bringoz.admin.authentication')
  .service('signupRequestsService', SignupRequestsService);
